export { PayByBankDetails } from './pay-by-bank-details';
